import moment from "moment";

const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";

export const toApiStartDate = (displayDate: string): string =>
  moment.utc(displayDate, DISPLAY_DATE_FORMAT).startOf("day").toISOString();

export const toApiEndDate = (displayDate: string): string =>
  moment.utc(displayDate, DISPLAY_DATE_FORMAT).endOf("day").toISOString();

export const formatMinutes = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
};

export const FALLBACK_COLORS = [
  "#1890ff",
  "#52c41a",
  "#faad14",
  "#f5222d",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
  "#fa8c16",
  "#a0d911",
  "#2f54eb",
];

export const getColor = (color: string | undefined, index: number) =>
  color && color !== "#000000" && color !== ""
    ? color
    : FALLBACK_COLORS[index % FALLBACK_COLORS.length];

export type Resolution = "day" | "week" | "month";

export const getResolution = (start: string, end: string): Resolution => {
  const days = moment(end, DISPLAY_DATE_FORMAT).diff(
    moment(start, DISPLAY_DATE_FORMAT),
    "days",
  );
  if (days <= 31) return "day";
  if (days <= 90) return "week";
  return "month";
};

export const getBucketKey = (date: string, resolution: Resolution): string => {
  if (resolution === "week")
    return moment(date).startOf("isoWeek").format("YYYY-MM-DD");
  if (resolution === "month")
    return moment(date).startOf("month").format("YYYY-MM-DD");
  return moment(date).format("YYYY-MM-DD");
};

export const formatBucketLabel = (
  key: string,
  resolution: Resolution,
): string => {
  if (resolution === "month") return moment(key).format("MMM YYYY");
  if (resolution === "week") return moment(key).format("MMM D");
  return moment(key).format("MMM D");
};
